import React, {useEffect, useState} from 'react'
import {ListViewProvider} from '../../../../../_metronic/common/table/core/ListViewProvider'
import {useAuth} from '../../../auth'
import {useParams} from 'react-router-dom'
import {QUERIES, isNotEmpty} from '../../../../../_metronic/helpers'
import {useQuery} from 'react-query'
import {getJobById} from '../jobs-list/core/_requests'
import {ListLoading} from '../../../../../_metronic/common/table/loading/ListLoading'
import {JobHeader} from './JobHeader'
import {JobBody} from './JobBody'

export const JobDetails = () => {
  const {currentUser} = useAuth()
  const {jobId} = useParams()
  const [enabledQuery, setEnabledQuery] = useState<boolean>(isNotEmpty(jobId))

  useEffect(() => {
    setEnabledQuery(isNotEmpty(jobId))
  }, [jobId])

  const {isLoading, data: job} = useQuery(
    `${QUERIES.JOB_DETAILS}-job-${jobId}`,
    () => {
      return getJobById(jobId, currentUser)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        console.error(err)
      },
    }
  )
  // const {itemIdForUpdate, action} = useListView()
  return (
    <>
      {isLoading ? (
        <>
          <ListLoading />
        </>
      ) : (
        <>
          <JobHeader job={job} isLoading={isLoading} />
          <JobBody job={job} isLoading={isLoading} />

          {/* {action !== undefined && (
            <>
              <StockActionsModalWrapper action={action} />
            </>
          )}

          {itemIdForUpdate !== undefined && (
            <>
              <EditModal title={itemIdForUpdate === null ? 'Add Stock' : 'Edit Stock'}>
                <StockEditModalFormWrapper />
              </EditModal>
            </>
          )} */}
        </>
      )}
    </>
  )
}

export const JobkWrapper = () => {
  return (
    <>
      <ListViewProvider>
        <JobDetails />
      </ListViewProvider>
    </>
  )
}
